import { ApiOperationBase } from 'api/rtk-api'
import { Currency, formatCurrencyFull } from 'utilities/currency'
import { formatUnits } from 'utilities/number'

import { Amount, MetaInformation } from './event-information'

const Price = ({
  currency,
  status,
  value
}: {
  currency: Currency
  status: string
  value: number
}) => (
  <span>
    {status} price:{' '}
    <strong>
      {formatCurrencyFull(
        currency === 'ZAR' ? value * 100 : value,
        currency,
        null,
        currency === 'ZAR'
      )}
    </strong>
  </span>
)

export interface OrderCorrectionProps {
  currency: Currency
  operation: ApiOperationBase
}

export const OrderCorrection = ({ currency, operation }: OrderCorrectionProps) => {
  const instruction = operation.associatedInstruction as any

  return (
    <MetaInformation>
      <span>
        Asset Id: <strong>{instruction.assetId}</strong>
      </span>
      {instruction.sharesCorrection && (
        <span>
          Units: <strong>{formatUnits(instruction.sharesCorrection)}</strong>
        </span>
      )}
      {instruction.cashCorrection && (
        <Amount currency={currency} value={instruction.cashCorrection} />
      )}
      <Price currency={currency} status="Original" value={instruction.incorrectPrice} />
      <Price currency={currency} status="Corrected" value={instruction.correctPrice} />
    </MetaInformation>
  )
}
